import './modernizr-custom.js'
import { gsap } from 'gsap'
import { createTimeline, cubicBezier } from 'animejs'
import { DefaultTransition, WorkToWorkTransition } from './transitions.mjs'
import { DefaultRenderer, WorkGridRenderer, WorkListRenderer, AboutRenderer, ProjectRenderer, HomepageOldRenderer, HomepageRenderer, PeopleRenderer, ArchiveRenderer } from './renderers.mjs'
import { Core } from '@unseenco/taxi'

// Sets homepage intro animation to only fire on homepage
window.isTaxiTransition = false;

/* Set up Taxi */
export const t = new Core({
  links: 'a:not([target]):not([href^=\\#]):not([data-taxi-ignore])',
  renderers: {
    default: DefaultRenderer,
    home: HomepageRenderer,
    workGrid: WorkGridRenderer,
    workList: WorkListRenderer,
    project: ProjectRenderer,
    people: PeopleRenderer,
    archive: ArchiveRenderer,

    // OLD ONES
    homeOld: HomepageOldRenderer,
    about: AboutRenderer,
  },
  transitions: {
    default: DefaultTransition,
    workToWork: WorkToWorkTransition,
  }
});


/* Work Grid <-> Work List Routes */
t.addRoute('/work', '/work/list', 'workToWork')
t.addRoute('/work/list', '/work', 'workToWork')




t.on('NAVIGATE_IN', (params) => {
  window.isTaxiTransition = true;
})

/* Mobile nav */
const mobileNavToggle = document.querySelector('.js-mobile-nav-toggle');
const mobileNav = document.querySelector('.js-mobile-nav');
const siteLogo = document.querySelector('.site-logo__svg');

const EASE = cubicBezier(0.358, 0.002, 0, 1);

mobileNavToggle?.addEventListener('click', () => {
  const isOpen = mobileNav.classList.toggle('is-open');
  const links = document.querySelectorAll('.js-mobile-nav-ani');

  mobileNavToggle.classList.toggle('is-open', isOpen);
  mobileNavToggle.setAttribute('aria-expanded', isOpen);
  mobileNav.setAttribute('aria-hidden', !isOpen);
  siteLogo.classList.toggle('is-white', isOpen);

  if (isOpen) {
    const tl = createTimeline({ defaults: { easing: EASE } });
    links.forEach((link, i) => {
      const offset = i * 70;
      tl.add(link, { translateY: [80, 0], duration: 450 }, offset)
        .add(link, { opacity: [0, 1], duration: 550 }, offset);
    });
  } else {
    gsap.to(links, {opacity: 0, delay: 0.4, duration: 0,});
  }
});

mobileNav?.querySelectorAll('a').forEach(link => {
  link.addEventListener('click', () => {
    if (link.classList.contains('js-copy-email')) return;
    mobileNav.classList.remove('is-open');
    mobileNavToggle.classList.remove('is-open');
    mobileNavToggle.setAttribute('aria-expanded', false);
    mobileNav.setAttribute('aria-hidden', true);
    siteLogo.classList.remove('is-white');
  });
});

siteLogo?.addEventListener('click', () => {
  if (!mobileNav?.classList.contains('is-open')) return;
  mobileNav.classList.remove('is-open');
  mobileNavToggle.classList.remove('is-open');
  mobileNavToggle.setAttribute('aria-expanded', false);
  mobileNav.setAttribute('aria-hidden', true);
  siteLogo.classList.remove('is-white');
});

const hoverEmailEl = document.querySelector('.js-hover-email');
if (hoverEmailEl) {
  const originalText = hoverEmailEl.textContent;
  hoverEmailEl.addEventListener('mouseenter', (e) => {
    e.currentTarget.textContent = e.currentTarget.dataset.hover;
  });
  hoverEmailEl.addEventListener('mouseleave', (e) => {
    e.currentTarget.textContent = originalText;
  });
}
/*
document.querySelectorAll('.js-copy-email').forEach(el => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    const email = e.currentTarget.dataset.email;
    navigator.clipboard.writeText(email).then(() => {
      const link = e.currentTarget;
      const original = link.textContent;
      link.textContent = 'Copied!';
      setTimeout(() => { link.textContent = original; }, 2000);
    });
  });
});
*/

t.on('NAVIGATE_OUT', (params) => {
  if (!(params.trigger instanceof HTMLElement)) return;
  const destinationPath = new URL(params.trigger.href).pathname
  document.querySelectorAll('.site-nav a').forEach(link => {
    const linkPath = new URL(link.href).pathname
    link.classList.toggle('is-active', destinationPath.startsWith(linkPath) && linkPath !== '/')
  })
  document.querySelectorAll('.work-nav a').forEach(link => {
    const linkPath = new URL(link.href).pathname
    link.classList.toggle('active', destinationPath === linkPath)
  })
})